import {faCircleInfo} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import React from 'react'
import {Alert} from 'react-bootstrap'
import {Link} from 'react-router-dom'

const ConnectChannelAlert: React.FC = () => {
  return (
    <Alert variant='info' className='d-flex p-1 mt-3 mx-auto' style={{maxWidth: '94%'}}>
      <span style={{marginTop: '1px'}}>
        <FontAwesomeIcon icon={faCircleInfo} />
      </span>
      <div className='ms-2'>
        <span style={{fontSize: 'small', fontWeight: 700}}>Connect a Channel to Begin</span>
        <div className='' style={{fontSize: 'small', fontWeight: 500}}>
          You're just one step away from automating your sales! Go to the{' '}
          <Link to='/platforms' style={{color: '0d6efd', textDecoration: 'none'}}>
            Channel List
          </Link>{' '}
          to connect your core system and start streamlining your processes.
        </div>
      </div>
    </Alert>
  )
}

export default ConnectChannelAlert
